
























































































































import Vue, { PropType } from 'vue';
import axios from 'axios';
import { debounce } from 'lodash';

import {
  options,
  Option,
  OptionValue,
} from 'mostra';

interface DataType {
  spHeight: number;
  loading: boolean;
  orientationType: number;
  orientationTypes: Option;
  spDisplayTypes: Option;
  pcDisplayTypes: Option;
  tabletDisplayTypes: Option;
  tabletDisplayType: number;
  pcDisplayType: number;
  displayGroupType: number;
  displayGroupTypes: Option;
  innerValue: any;
}

export default Vue.extend({
  name: 'g-preview-form',
  data(): DataType {
    return {
      spHeight: 0,
      loading: true,
      orientationType: 1,
      orientationTypes: options.orientationTypes,
      displayGroupType: 1,
      pcDisplayTypes: options.pcDisplayTypes,
      tabletDisplayTypes: options.tabletDisplayTypes,
      tabletDisplayType: 101,
      pcDisplayType: 3,
      spDisplayTypes: options.spDisplayTypes,
      displayGroupTypes: options.displayGroupTypes,
      innerValue: null,
    };
  },
  props: {
    src: {
      type: String as PropType<string>,
      required: true,
    },
    value: {
      type: Object,
      required: true,
    },
  },
  computed: {
    displayGroupTypeOption(): OptionValue {
      return options.get(this.displayGroupTypes, this.displayGroupType);
    },
    // pcDisplayTypeOption(): OptionValue {
    //   return options.get(this.pcDisplayTypes, this.pcDisplayType);
    // },
  },
  watch: {
    value: {
      /* eslint func-names: off */
      handler: debounce(function (newVal: any) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this.reloadByVal(newVal);
      }, 3000),
      deep: true,
    },
  },
  methods: {
    async reloadByVal(newVal: any) {
      try {
        this.loading = true;
        const res = await axios
          .post(this.src, newVal);
        this.innerValue = res.data;
      } catch (error: any) {
        this.$fatal(error);
      } finally {
        this.loading = false;
      }
      this.$nextTick(() => {
        const dom = this.$refs.spprevew as any;
        if (dom) {
          this.spHeight = dom.clientHeight;
        }
      });
    },
    async reload() {
      await this.reloadByVal(this.value);
    },
    async onClick() {
      try {
        this.$loading(true);
        await this.reload();
      } finally {
        this.$loading(false);
      }
    },
  },
  async mounted() {
    await this.reload();
  },
});
